import { Box } from '@mui/material';
import '../assets/landing/css/landing-custom.css';
import About from '../components/landing/About';
import Contact from '../components/landing/Contact';
import Content from '../components/landing/Content';
import FAQ from '../components/landing/FAQ';
import Features from '../components/landing/Features';
import FooterSection from '../components/landing/FooterSection';
import HeroBanner from '../components/landing/HeroBanner';
import NavBar from '../components/landing/NavBar';
import News from '../components/landing/News';
import Testimonials from '../components/landing/Testimonials';

function Landing() {
  return (
    <Box
      className="landing-page-root"
      sx={{
        width: '100%',
      }}
    >
      <NavBar />
      <HeroBanner />
      <Features />
      <About />
      <Content />
      <FAQ />
      <Testimonials />
      <News />
      <Contact />
      <FooterSection />
    </Box>
  );
}

export default Landing;
